import React from 'react'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'
import { getKambiCouponBetType } from '@core/Areas/KambiSports/helpers/getKambiCouponBetType'
import { Single, SameGameMulti, Multi } from './Components'

export const BetInfo: React.FC<{
  historyCoupon: BetLoopKambiShareCoupon | KambiHistoryCoupon
}> = ({ historyCoupon }) => {
  const betType = getKambiCouponBetType(historyCoupon)
  const outcomes = historyCoupon.outcomes ?? []

  if (betType === 'same-game-multi') {
    const { events, bets, betOffers } = historyCoupon

    return (
      <SameGameMulti
        legCount={outcomes.length}
        event={events[0]}
        outcomes={outcomes}
        betOffers={betOffers}
        betStatus={bets[0].betStatus}
        playedOdds={bets[0].playedOdds}
      />
    )
  }

  if (betType === 'multi') {
    return <Multi historyCoupon={historyCoupon} />
  }

  if (betType === 'single') {
    const { events, bets, betOffers } = historyCoupon
    return (
      <Single
        betRef={bets[0].betRef}
        event={events[0]}
        outcome={outcomes[0]}
        betOffers={betOffers}
        betStatus={bets[0].betStatus}
        playedOdds={bets[0].playedOdds}
      />
    )
  }

  return !PRODUCTION ? <div>Unknown Kambi Bet Type</div> : null
}
